import { render, staticRenderFns } from "./cleanSearch.vue?vue&type=template&id=1f8f06bf&scoped=true&"
import script from "./cleanSearch.vue?vue&type=script&lang=js&"
export * from "./cleanSearch.vue?vue&type=script&lang=js&"
import style0 from "./cleanSearch.vue?vue&type=style&index=0&id=1f8f06bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f06bf",
  null
  
)

export default component.exports